export function isExternalLink (link: string, location: Location) {
  if (!link) return false

  return link.replace('https://', '').replace('http://', '').indexOf(location.hostname) !== 0 && !link.match(/^\/[^/]/)
}
